import { ITrainingCourseFiltersResponse } from '@/types/views/trainingCourse.types';
import { useAppQuery } from './useAppQuery';

interface Props {
  providerIds?: string[];
}

export const useGetTrainingCourseFilters = ({ providerIds }: Props = {}) => {
  return useAppQuery<ITrainingCourseFiltersResponse>('/TrainingManager/courses/filters', {
    config: {
      params: {
        providerIds: providerIds?.length ? providerIds : undefined,
      },
      paramsSerializer: { indexes: null },
    },
  });
};
